import React from 'react';

import Framework from "@beardeddevops/react.framework";
import {Objects, Collections} from "components";

import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import {Button} from "reactstrap";
import Types from "../../../../../constants/Types";
import API from "@beardeddevops/react.api";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import {confirmAlert} from "react-confirm-alert";
import Access from "constants/Access";
import {ListItemText} from "@material-ui/core";
import UniversalModalOverride from "../../../../../components/UniversalModalOverride";

class Disposition extends Framework.Components.View {

	constructor(props) {
		super(props, 'details');
		this.state.question = null;
		this.state.question_binary_id = null;
		this.state.signatures = [];
		this.state.transaction_signatures = [];
		this.state.location = null;
		this.state.location_binary_id = null;
		this.state.toggleForm = false;

		this.state.anchorGen = null;
	}

	updateData = (id, binary_id, signatures, transaction_signatures, location, location_binary_id) => {
		this.setState({
			question: id,
			question_binary_id: binary_id,
			signatures: signatures,
			transaction_signatures: transaction_signatures,
			location: location,
			location_binary_id: location_binary_id
		})
	};

	toggle = (name) => () => {
		this.handleClose();
		this.setState({[name]: !this.state[name]});
	};

	handleOpen = (el) => event => {
		this.setState({
			[el]: event.currentTarget,
		});
	};

	handleClose = () => {
		this.setState({
			anchorGen: null,
		});
	};

	sendCleo = (form) => async () => {
		this.handleClose();
		confirmAlert({
			title: 'Send to CLEO',
			message: 'Do you want to send this to CLEO?',
			buttons: [
				{
					label: 'Yes',
					onClick: async () => {
						this.setState({loading: true})
						await this.printPdf(form, true)();
						this.setState({loading: false})
					}
				},
				{
					label: 'No',
					onClick: async () => {
						this.setState({loading: true})
						await this.printPdf(form, false)();
						this.setState({loading: false})
					}
				}
			]
		});
	};


	printPdf = (form, sendEmail) => async () => {
		this.handleClose();
		let model = new API.BuildClass(Types.Transactions_Collections_Forms._name, API.RequestType.CREATE);

		model.object.form = form;
		model.object.send_email = sendEmail;
		model.object.location = this.state.location;
		model.object.location_binary_id = this.state.location_binary_id;
		model.parent = this.props.match.params.id;

		try {
			await model.submit(null, API.RequestType.CREATE);
		} catch (e) {
			return;
		}

		this.setState({tab: 'forms'})

		this.refreshPage();
	};

	generatedForm = () => {
		this.refreshPage();
		this.setState({tab: 'forms'});
	};

	/**
	 *
	 */
	handleAfterP12Save = () => {
		this.refreshPage();
	}

	toggleForm = () => {
		this.setState({toggleForm: !this.state.toggleForm})
		this.handleClose();
	};

	render() {
		const {anchorGen, loading} = this.state;

		let currentActiveLocation = this.props.rootState.locations.find(loc => loc.pkey === this.state.location);
		let breadcrumbs = [
			{
				name: 'Dashboard',
				url: this.props.kioskMode ? `/dispositions/${this.props.match.params.id}` : '/',
				icon: 'dashboard',
			},
			{
				name: 'Dispositions',
				url: this.props.kioskMode ? `/dispositions/${this.props.match.params.id}` : '/dispositions',
				icon: 'download',
			},
			{
				name: this.state.name,
				url: `/dispositions/${this.props.match.params.id}`,
				icon: 'file-text-o',
			}
		];

		return (
			<div className="container-fluid">

				<Framework.Components.PageBar breadcrumbs={breadcrumbs} history={this.props.history}>
					{!this.props.kioskMode && <Button onClick={()=>this.props.history.push('/dispositions/enics_statuses')} size="sm" color="primary">
						<i className="fa fa-check-square-o"/>&nbsp;&nbsp;Assisted LEEP
					</Button>}
					{!this.props.kioskMode && <Button
						size={"sm"}
						color="primary"
						aria-owns={anchorGen ? 'anchorGen' : null}
						aria-haspopup="true"
						onClick={this.handleOpen('anchorGen')}
					>
						<i className="fa fa-file-pdf-o"/>&nbsp;&nbsp;Generate Form
					</Button>}
					<Menu
						id="anchorGen"
						anchorEl={anchorGen}
						open={Boolean(anchorGen)}
						onClose={this.handleClose}
						getContentAnchorEl={null}
						anchorOrigin={{horizontal: 'left', vertical: 'bottom'}}
						transformOrigin={{horizontal: 'left', vertical: 'top'}}
					>
						<MenuItem onClick={this.printPdf(21, false)}>
							<ListItemText inset primary="ATF 4473 (Disposition Form)"/>
						</MenuItem>
						<MenuItem onClick={this.printPdf(2, false)}>
							<ListItemText inset primary="ATF 3310.12 (Multiple Sale Form of Certain Rifles)"/>
						</MenuItem>
						<MenuItem onClick={this.sendCleo(3)}>
							<ListItemText inset primary="ATF 3310.4 (Multiple Sale Form of Pistols/Revolvers)"/>
						</MenuItem>
						{this.props.rootState.hasMichiganRIModule && <MenuItem onClick={this.printPdf(26, false)}>
						<ListItemText inset primary="Michigan RI-060 Form Generation"/>
						</MenuItem>
						}
						{this.props.rootState.hasNYP12Module && <MenuItem onClick={() => this.toggleForm()}>
							<ListItemText inset primary="Generate P12 Form"/>
						</MenuItem>
						}
						
					</Menu>
					{!this.props.kioskMode && <Button onClick={this.toggle('modalUpload')} size="sm" color="primary">
						<i className="fa fa-check-square-o"/>&nbsp;&nbsp;Attach File
					</Button>}
				</Framework.Components.PageBar>

				<Tabs value={this.state.tab} onChange={this.handleTabChange} component={'div'}>
					<Tab label="Disposition" value={'details'}/>
					<Tab label="Signatures" value={'signatures'}/>
					<Tab label="Eligibility" value={'eligibility'}/>
					<Tab label="Forms" value={'forms'}/>
					<Tab label="Uploaded Files" value={'upload'}/>
					{ this.props.userAccess <= Access.Manager && <Tab label="Change Log" value={'logs'}/>}
				</Tabs>

				<div style={{display: this.state.tab === 'details' ? 'block' : 'none'}}>
					<Objects.DispositionEdit
						id={this.props.match.params.id}
						history={this.props.history}
						locations={this.props.locations}
						states={this.props.states}
						reloadShell={this.props.reloadShell}
						reloadPage={this.refreshPage}
						reloadSelf={this.state.refresh}
						generatedForm={this.generatedForm}
						toggleForm={this.state.toggleForm}
						updateName={this.updateName}
						updateData={this.updateData}
						baseUrl={this.props.baseUrl}
						scannedCode={this.props.scannedCode}
						userAccess={this.props.userAccess}
						question = {this.state.question}
					/>
				</div>
				{this.state.tab === 'signatures' &&
				<Objects.DispositionSignatures
					parent={this.props.match.params.id}
					history={this.props.history}
					locations={this.props.locations}
					states={this.props.states}
					reloadShell={this.props.reloadShell}
					reloadPage={this.refreshPage}
					reloadSelf={this.state.refresh}
					baseUrl={this.props.baseUrl}
					signatures={this.state.signatures}
					transactionSignatures={this.state.transaction_signatures}
				/>}
				{this.state.tab === 'eligibility' &&
				<Objects.DispositionQuestions
					id={this.state.question}
					binary_id={this.state.question_binary_id}
					parent={this.props.match.params.id}
					history={this.props.history}
					locations={this.props.locations}
					states={this.props.states}
					reloadShell={this.props.reloadShell}
					reloadPage={this.refreshPage}
					reloadSelf={this.state.refresh}
					baseUrl={this.props.baseUrl}
				/>}
				{this.state.tab === 'forms' &&
				<Collections.Forms
					parent={this.props.match.params.id}
					forForm={Types.Transactions_Collections_Forms._name}
					url="/transactions/[PARENT]/collections_forms"
					history={this.props.history}
					locations={this.props.locations}
					states={this.props.states}
					reloadShell={this.props.reloadShell}
					reloadPage={this.refreshPage}
					reloadSelf={this.state.refresh}
					afterSave={this.handleAfterP12Save}

				/>}
				{this.state.tab === 'upload' &&
				<Collections.TransactionUploads
					parent={this.props.match.params.id}
					// forForm={Types.Transactions_Collections_Forms._name}
					// url="/transactions/[PARENT]/collections_forms"
					history={this.props.history}
					locations={this.props.locations}
					states={this.props.states}
					reloadShell={this.props.reloadShell}
					reloadPage={this.refreshPage}
					reloadSelf={this.state.refresh}
				/>}
				{this.state.tab === 'logs' && this.props.userAccess <=Access.Manager&&
				<Collections.LogsDispositions
					parent={this.props.match.params.id}
					history={this.props.history}
					locations={this.props.locations}
					states={this.props.states}
					reloadShell={this.props.reloadShell}
					reloadPage={this.refreshPage}
					reloadSelf={this.state.refresh}
				/>}
				<Framework.Elements.LoadingSpinner isLoading={loading}/>

				<UniversalModalOverride
					locations={this.props.locations}
					states={this.props.states}
					name="Attached File"
					object={Objects.TransactionUpload}
					history={this.props.history}
					toggle={this.state['modalUpload']}
					reportClose={this.reportClose('modalUpload')}
					afterSave={this.handleAfterSave}
					url="dispositions"
					objectProps={{
						// type: this.props.type,
						// handleTabChange: this.props.handleTabChange
					}}
				/>


				{/*<UniversalModalOverride*/}
				{/*	locations={this.props.locations}*/}
				{/*	states={this.props.states}*/}
				{/*	name="Attached File"*/}
				{/*	object={Objects.FormP12}*/}
				{/*	history={this.props.history}*/}
				{/*	toggle={this.state['formP12']}*/}
				{/*	reportClose={this.reportClose('formP12')}*/}
				{/*	afterSave={this.handleAfterSave}*/}
				{/*	url="dispositions"*/}
				{/*	size="xl"*/}
				{/*/>*/}
			</div>
		);
	}
};


export default Framework.Components.withRootState(Disposition);
